import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import TopBar from "../../components/TopBar";
import Footer from "../../components/Footer";
import ViewerImage from "../../components/ViewerImage";
import ImageMagnifier from "../../components/ImageMagnifier";
import { isMobileDevice, scrollToTop } from "../../utils";
import Product from "./Product";
import { useLocation, useNavigate } from "react-router";
import { addCart, productDetail } from "../../API";
import { getQueryParam } from "../../utils/getUrlParamsLegacy";
import { Select, message } from "antd";
import { showLoding } from "../../utils/tool";

const ComponentName: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate()

  const [imgSeeLi, setImgSeeLi]: any = React.useState([])
  const category = getQueryParam('category')
  const [productInfo, setProductInfo]: any = React.useState()
  const [sizePrices, setSizePrices]: any = React.useState()
  const handleLoad = () => {
    const id = getQueryParam('id')
    productDetail(id).then((res: any) => {
      setProductInfo(res?.data)

      setImgSeeLi(res?.data?.imageJson.map((item: any, index: number) => ({
        src: item?.url,
        alt: index
      })))

      if (res?.data?.sizePrices && res?.data?.sizePrices.length > 0) {
        setSizePrices(res?.data?.sizePrices.map((item: any, index: number) => ({
          value: item?.size,
          label: item?.size,
          originPrice: item?.originPrice,
          currentPrice: item?.currentPrice,
          content: item?.content,
          sizeId: item?.sizeId
        })))
      }

    }).catch((err: any) => {
      console.log(err)
    })
  }

  const childRef: any = useRef(null);
  const { pathname, search } = useLocation();
  useEffect(() => {
    handleLoad() 
    scrollToTop()
  }, [search])

  const handleaddCart = () => {
    if (productInfo?.sizePrices && productInfo?.sizePrices.length && !selectPrice) {
      message.error('請選擇尺寸')
      return
    } 
    showLoding(true)
    addCart({
      productId: productInfo?.id,
      productNum: productNum,
      sizeId: selectPrice?.sizeId,
    }).then((res: any) => {
      console.log(res)
      message.success('加入購物車成功')
      childRef.current?.handleCard();
    }).catch((err: any) => {
      console.log(err)
    }).finally(() => {
      showLoding(false)
    })
  }
  const [selectPrice, setSelectPrice]: any = React.useState()
  const handleChange = (value: string, option: any) => {
    console.log(`selected ${value}`);
    console.log(option);
    setSelectPrice(option)
  };

  const [productNum, setProductNum]: any = React.useState(1)

  return (
    <div className="">
      <TopBar ref={childRef} />
      <div className=" w-[1200px] mx-auto h5:w-full">

        {/* <div className="flex items-center pr-[20px] rounded-lg mt-[30px] overflow-hidden h5:mx-16"
          style={{
            border: '1px solid rgba(0, 0, 0, .1)'
          }}
        >
          <div className="w-[4px] bg-[#000] mr-[18px]"></div>
          <div className="flex-1 py-[18px]">{productInfo?.title}</div>
          <div className="text-[#fff] text-[14px] font-bold px-[18px] py-[12px] cursor-pointer bg-[#000] my-[16px] rounded-lg"
            onClick={() => navigate('/cart')}
          >查看購物車</div>
        </div> */}

        <div className="my-[30px] flex items-center text-[#181512] text-[16px] h5:px-16">
          <div className="text-[#595959] text-[16px] mr-4 cursor-pointer" onClick={() => navigate('/')}>首頁</div>
          /
          <div className="text-[#181512] text-[16px] ml-4">{category}</div>
        </div>

        <div className="flex h5:block"> 
          <div className="w-[800px] h-[686px] px-15 relative group h5:w-full h5:h-[370px]">
            <div className="absolute top-0 right-[15px] z-20 hidden group-hover:block">
              <ViewerImage
                images={
                  imgSeeLi
                }
              />
            </div>
            <ImageMagnifier
              src={productInfo?.imageJson[0]?.url ? productInfo?.imageJson[0]?.url : productInfo?.imageUrl}
              alt="图片描述"
              zoomLevel={2.5}
              width={isMobileDevice() ? window.innerWidth - 30 : 770}
              height={isMobileDevice() ? 370 : 686}
            />
          </div>
          <div className="flex-1 px-15">
            <div className="text-[#595959] text-[15px] mb-4 h5:mt-6">{category}</div>
            <div className="text-[#3c342e] text-[46px] font-bold pt-6 h5:text-[36px]"
              style={{
                lineHeight: isMobileDevice() ? '40px' : '54px',
              }}>{productInfo?.title}</div>
            <div className="flex items-center my-[30px] h5:my-[20px]">
              <div className="text-[#595959] text-[26px] line-through mr-2">USD{productInfo?.originalPrice}</div>
              <div className="text-[#3c342e] text-[30px] ml-4"> USD{productInfo?.currentPrice}</div>
            </div>
            <div className="text-[#595959] text-[14px] mb-[30px] h5:mb-[20px]">商品編號： {productInfo?.number}</div>
            {
              productInfo?.sizePrices && productInfo?.sizePrices.length > 0 ?
                <div>
                  <div className=" flex items-center mb-[30px] h5:mb-[20px]">
                    <div className="text-[#3c342e] text-[18px] font-bold">尺寸</div>
                    <div className="pl-20">
                      <Select
                        placeholder="請選取一個選項"
                        style={{ width: 160 }}
                        onChange={handleChange}
                        className="flex-1 px-[15px] py-[10px] rounded-md outline-none text-[#181512] text-[14px]"
                        options={sizePrices}
                      />
                    </div>
                  </div>
                  <div className={`${!!selectPrice ? 'block' : 'hidden'}`}>
                    <div className="text-[#3c342e] text-[14px] font-bold">商品參數 : </div>
                    <div className="text-[#595959] text-[14px]">品名 :  {selectPrice?.content}</div>
                    <div className="text-[#595959] text-[14px]">尺寸 :  {selectPrice?.label}</div>
                    <div className="flex items-center mt-[10px] mb-[30px] ">
                      <div className="text-[#595959] text-[26px] mr-2 line-through ">USD{selectPrice?.originPrice}</div>
                      <div className="text-[#3c342e] text-[30px] ml-4"> USD{selectPrice?.currentPrice}</div>
                    </div>
                  </div>
                </div>
                :
                <div className="text-[#595959] text-[14px] mb-[30px] h5:mb-[20px]">{productInfo?.size}</div>
            } 
            {/* <input type="number" className="w-[55px] h-[55px] p-1 rounded-sm text-center focus:outline-none"
              value={productNum}
              onChange={(e) => {
                if (e.target.value === '') {
                  setProductNum(1)
                } else {
                  setProductNum(Number(e.target.value))
                }
              }}
              style={{
                border: '1px solid rgba(0, 0, 0, .2)'
              }} /> */}
            {/* <div className="bg-[#000] rounded-[4px] flex items-center justify-center py-[18px] text-[#fff] text-[18px] cursor-pointer
                    mt-[30px]"
              onClick={(e) => {
                e.stopPropagation();
                handleaddCart()
              }}>
              <img src={require("../../assets/image/icon3_1.png")} className='w-[26px] mr-4' alt="" />
              加入購物車
            </div> */}
            <div className="flex w-[240px] h-[50px] mt-[30px]"
              style={{
                backgroundImage: 'url(' + require('../../assets/image/icon21.png') + ')',
                backgroundSize: 'contain',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
              }}>
              <div className="flex-1 h-[50px]">
                <a href="javascript:;" className="w-full h-[50px] inline-block"
                  target="_blank" rel="noopener noreferrer"
                  onClick={() => {
                    window.open('http://www.facebook.com/sharer.php?u=https%3A%2F%2Fwww.scanteak.com.tw%2Fproduct%2Ft10251-kodda-2s%2F', 'share', 'toolbar=0,status=0,width=620,height=280');
                    return false;
                  }}
                ></a>
              </div>
              <div className="flex-1 h-[50px]">
                <a href="javascript:;" className="w-full h-[50px] inline-block"
                  target="_blank" rel="noopener noreferrer"
                  onClick={() => {
                    window.open('https://twitter.com/intent/tweet?url=https%3A%2F%2Fwww.scanteak.com.tw%2Fproduct%2Ft10251-kodda-2s%2F&text=T10251-KODDA+2%E4%BA%BA%E5%BA%A7%E5%AF%A6%E5%BF%83%E6%9F%9A%E6%9C%A8%E6%B2%99%E7%99%BC', 'share', 'toolbar=0,status=0,width=620,height=280');
                    return false;
                  }}
                ></a>
              </div>
              <div className="flex-1 h-[50px]">
                <a href="javascript:;" className="w-full h-[50px] inline-block"
                  target="_blank" rel="noopener noreferrer"
                  onClick={() => {
                    window.open('https://lineit.line.me/share/ui?url=https%3A%2F%2Fwww.scanteak.com.tw%2Fproduct%2Ft10251-kodda-2s%2F&text=T10251-KODDA+2%E4%BA%BA%E5%BA%A7%E5%AF%A6%E5%BF%83%E6%9F%9A%E6%9C%A8%E6%B2%99%E7%99%BC', 'share', 'toolbar=0,status=0,width=620,height=280');
                    return false;
                  }}
                ></a>
              </div>
              <div className="flex-1 h-[50px]">
                <a href="javascript:;" className="w-full h-[50px] inline-block"
                  target="_blank" rel="noopener noreferrer"
                  onClick={() => {
                    window.open('http://pinterest.com/pin/create/button/?url=https%3A%2F%2Fwww.scanteak.com.tw%2Fproduct%2Ft10251-kodda-2s%2F', 'share', 'toolbar=0,status=0,width=620,height=280');
                    return false;
                  }}
                ></a>
              </div>
            </div>
          </div>
        </div>

        <div className="flex mt-[130px] pt-[30px] h5:block h5:px-16 h5:mt-[100px]"
          style={{
            display: !!productInfo?.materials ? 'flex' : 'none',
            borderTop: '1px solid rgba(0, 0, 0, .2)'
          }}>
          <div className="flex-1">
            <div className="text-[#181512] text-[24px] font-bold">商品材質</div>
            <div className="mt-[30px] flex items-center">
              {
                productInfo?.materials?.map((item: any) => (
                  <div className="mb-20 mr-10 w-[130px]" key={item?.title}>
                    <img src={item?.url}
                      className="rounded-full w-full h-[130px]" alt="" />
                    <div className="text-[#595959] text-[16px] font-bold text-center pt-16">{item?.title}</div>
                  </div>
                ))
              }
            </div>
          </div>
          <div className="w-[30px]"></div>
          <div className="flex-1 h5:pt-[30px] h5:mt-[30px]"
            style={{
              display: !!productInfo?.specs ? 'block' : 'none',
              borderTop: isMobileDevice() ? '1px solid rgba(0, 0, 0, .2)' : ''
            }}>
            <div className="text-[#181512] text-[24px] font-bold">商品細節</div>
            <div className="text-[#595959] text-[16px] mt-[30px] font-bold">
              Length
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              {productInfo?.specs?.length}</div>
            <div className="text-[#595959] text-[16px] mt-[10px] font-bold">
              Width
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              {productInfo?.specs?.width}</div>
            <div className="text-[#595959] text-[16px] mt-[10px] font-bold">
              Height
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              {productInfo?.specs?.height}</div>
          </div>
        </div>

        <div className="px-[100px] mt-[130px] pt-[30px] h5:px-16 h5:mt-[100px]"
          style={{
            display: !productInfo?.materials ? 'block' : 'none',
            borderTop: '1px solid rgba(0, 0, 0, .2)'
          }}>
          {
            productInfo?.descImageJson?.urls?.map((item: any) => (
              <img src={item} className="w-full" alt="" />
            ))
          }
        </div>

        <div className="text-[#181512] text-[38px] font-bold text-center my-[62px] h5:mb-[30px]">相關商品</div>
        <Product relatedProducts={productInfo?.relatedProducts} />

      </div>

      <Footer />
    </div>
  );
};

export default ComponentName;
